module.exports = __webpack_public_path__ + "img/banner.47ec0103.jpg";